import Contact from './Contact'
import './Contact.scss'

export default Contact
